import React, { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../../lib/api";
import { Card } from "../onboarding/adminUi";
import { fmtDate } from "../leads/PriorityBadge";

const List = ({ title, items, color, testid }) => items?.length ? (
  <div style={{ marginTop: 10 }} data-testid={testid}>
    <div style={{ fontSize: 12, fontWeight: 700, color }}>{title}</div>
    <ul style={{ margin: "4px 0 0 18px", fontSize: 13, color: "#d4d4d4" }}>{items.map((x, i) => <li key={i}>{x}</li>)}</ul>
  </div>
) : null;

export const AiRunCard = ({ rid, status, incomplete }) => {
  const [run, setRun] = useState(null);
  useEffect(() => { api.get(`/admin/plan-reviews/${rid}/ai-run`).then((x) => setRun(x.data)).catch(() => setRun({})); }, [rid, status]);
  if (!run?.id) return null;
  const out = run.output || {};
  return (
    <Card title="Borrador de la IA" testid="pr-ai-card"
      right={<span style={{ fontSize: 12, color: "#a3a3a3" }} data-testid="pr-ai-status">
        {run.status === "running" && <><Loader2 size={13} className="animate-spin" style={{ verticalAlign: -2 }} /> Generando…</>}
        {run.status === "done" && <><CheckCircle2 size={13} color="#4ade80" style={{ verticalAlign: -2 }} /> Generado {fmtDate(run.finished_at)} · {run.weeks} semanas</>}
        {run.status === "error" && <><XCircle size={13} color="#f87171" style={{ verticalAlign: -2 }} /> Error</>}
      </span>}>
      {run.status === "error" && <div style={{ color: "#f87171", fontSize: 13 }} data-testid="pr-ai-error">No se pudo generar: {run.error}. Puedes volver a intentarlo.</div>}
      {run.status === "running" && <div style={{ fontSize: 13, color: "#a3a3a3" }}>La IA está leyendo tu metodología, tu base de ejercicios y los datos del futbolista.</div>}
      {run.status === "done" && (<>
        {incomplete && <div style={{ background: "rgba(250,204,21,0.1)", border: "1px solid rgba(250,204,21,0.4)", color: "#fde68a", padding: "8px 12px", fontSize: 13 }} data-testid="pr-ai-incomplete">
          <AlertTriangle size={13} style={{ verticalAlign: -2 }} /> Borrador preliminar INCOMPLETO: {out.incomplete_reason}</div>}
        <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 8 }} data-testid="pr-ai-sources">
          Fuentes: {Object.entries(run.sources || {}).map(([k, v]) => <span key={k} style={{ marginRight: 10, color: v ? "#4ade80" : "#737373" }}>{v ? "✓" : "✗"} {k}</span>)}
        </div>
        <List title="Dudas y alertas para ti" items={out.alerts} color="#f87171" testid="pr-ai-alerts" />
        <List title="Preguntas pendientes" items={out.questions_for_coach} color="#facc15" testid="pr-ai-questions" />
        <List title="Datos que faltan" items={out.missing_data} color="#a3a3a3" testid="pr-ai-missing" />
        <div style={{ fontSize: 12, color: "#737373", marginTop: 10 }}>La IA nunca aprueba ni publica. Revisa y edita el borrador antes de aprobarlo.</div>
      </>)}
    </Card>
  );
};
